import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from '../../../components/ui';

// The shop and your orders are one place in the menu: a tab for each, each
// its own address
const TABS = [
  { id: 'kit', label: 'Kit', to: '/booking/shop' },
  { id: 'orders', label: 'My orders', to: '/booking/my-orders' },
];

export default function ShopTabs() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const value = pathname.startsWith('/booking/my-orders') ? 'orders' : 'kit';
  return (
    <Tabs
      label="Shop"
      tabs={TABS}
      value={value}
      onChange={(id) => { if (id !== value) navigate(TABS.find(t => t.id === id).to); }}
    />
  );
}
